import React from 'react';
import CapitalTerms from '@di-shared/features/capital/CapitalTerms';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';

export interface CapitalTermsPageProps {
  vin: string;
}

function CapitalTermsPage({vin}: CapitalTermsPageProps): JSX.Element {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header right={<HeaderCloseButton />} />
      <CapitalTerms vin={vin} />
    </div>
  );
}

export default CapitalTermsPage;
